import enums from '@/helpers/enums';
import { logError } from '@/helpers/errors';
import tinycolor from 'tinycolor2';

const mixin = {
  methods: {
    getColorWithOpacity(color, opacity) {
      const newColor = tinycolor(color);
      newColor.setAlpha(opacity);
      return newColor.toRgbString();
    },
    back() {
      this.$router.go(-1);
    },
    getUnitsLabel(unitId) {
      switch (unitId) {
        case enums.UNITS.INCHES:
          return '"';
        case enums.UNITS.MILLIMETERS:
          return 'mm';
      }
      return '';
    },
    getDrawerAppend(id) {
      return `drawerAppend-${id}`;
    },
    getNoteType(id) {
      return enums.NOTE_TYPE.find((x) => x.id === id) || {};
    },
    formatToHtml(text) {
      return (text || '').replaceAll('\n', '<br/>');
    },
    getBase64Link(data) {
      return `data:image/png;base64,${data}`;
    },
    logError
  }
};

export default mixin;
